import {Component, OnInit} from '@angular/core';
import {ComponentHelper, FormBaseComponent, ValidatorService} from '@utils-lib';
import {AppNameEnum, EroeffnungsbilanzWjAngabe} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-wirtschatsjahr-angaben',
    templateUrl: './wirtschatsjahr-angaben.component.html'
})
export class WirtschatsjahrAngabenComponent extends FormBaseComponent<EroeffnungsbilanzWjAngabe> implements OnInit {

    public erfassen: boolean;
    public isKapGAus = false;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                protected readonly activatedRoute: ActivatedRoute) {
        super(messageService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.erfassen = true;

        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
        if (appEnum === AppNameEnum.FragebogenKapGAus) {
            this.isKapGAus = true;
        }
    }

    public showVomBisAngaben(): boolean {
        return this.data?.wirtschaftsJahr;
    }

    public onWirtschaftsJahrChanged(): void {
        if(!this.data.wirtschaftsJahr) {
            this.form.get('abweichendesWirtschaftsjahrVon').setValue(null);
        }
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            wirtschaftsJahr: [this.data.wirtschaftsJahr],
            abweichendesWirtschaftsjahrVon: [this.data.abweichendesWirtschaftsjahrVon, [
                this.validatorService.conditionalValidator(
                    () => !!this.data.wirtschaftsJahr,
                    this.validatorService.required()
                ),
                this.validatorService.date()
            ]]
        });
    }

}
